import React, { useState } from "react";
import { Card, ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from "react-redux";
import { getKE, StatelessRadioGroupField } from '../lib';
import { Radio } from '@aws-amplify/ui-react';

const KompList = (props) => {
    const [kompArr] = useState(props.list.split(','));
    const komponenten = useSelector(state => state.menues ? state.menues.MENUEKOMPONENTEN : state.menues);
    const [showAllergeneUndZusatzstoffe] = useState(props.showAllergeneUndZusatzstoffe);
    const theLines = props.lines;
    const actLine = kompArr.length;
    const beilagenArr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']

    // console.log('KompList::kompArr', kompArr, actLine, theLines)

    const sparseRows = [];
    for (let i = actLine; i < theLines; i++) {
        // console.log('pushing', i)
        sparseRows.push(<Card.Text key={'empty_txt_' + i} >&nbsp;</Card.Text>)
    }

    /*    useEffect(() => {
            if (props.list && kompArr !== props.list.split(',')) {
                // console.log('useEffect + setState', props.list)
                setKompArr(props.list.split(','));
                //setAuswahl(props.list.length > 0 ? props.list[0].ID : '-1'); don't do this here! Lka, 05.05.2022
            }
            if (showAllergeneUndZusatzstoffe !== props.showAllergeneUndZusatzstoffe)
                setShowAllergeneUndZusatzstoffe(props.showAllergeneUndZusatzstoffe);
            // eslint-disable-next-line react-hooks/exhaustive-deps 
        }, [props])
    */
    if (props.list.length === 0 || kompArr[0] === '')
        return (<ListGroup ><ListGroup.Item variant="light"></ListGroup.Item></ ListGroup>)
    else {
        return (
            <Card style={{ minWidth: "100%", textAlign: "center", background: 'HoneyDew' }}
            >
                {props.istMitarbeiter ?
                    <Card.Title>Wählbare Beilage</Card.Title>
                    :
                    <Card.Title>Am Büffet wählbare Beilage</Card.Title>
                }
                <Card.Body >
                    <ListGroup>
                        <>
                            <StatelessRadioGroupField
                                Name="Sonstiges"
                                index={props.day}
                                handleChange={props.handleChange}
                                value={props.beilageState}
                            >

                                {
                                    kompArr.map((item, i) => {
                                        const theKomp = komponenten.filter((komp) => komp.ID === parseInt(item))[0];
                                        const theCardText = (<Card.Text key={`CT_${i}`}>{theKomp.BEZEICHNUNG}
                                            {showAllergeneUndZusatzstoffe && theKomp.ALLERGENEUNDZUSATZ > '' ? <sup key={`sup_${i}`} > {theKomp.ALLERGENEUNDZUSATZ}</sup> : ''}</Card.Text>);
                                        if (!theKomp) return null;
                                        if (!theKomp.BEZEICHNUNG) return null;

                                        const { KE, KCAL } = getKE([theKomp], komponenten);
                                        const kestr = `KE: ${KE}, kCal: ${KCAL}`;

                                        // console.log('Bezeichnung', theKomp)
                                        if (KE > 0 || KCAL > 0)
                                            return (
                                                <OverlayTrigger key={'card_body_ovl_KOMP_' + i} placement='top' delay={{ show: 400, hide: 400 }} overlay={
                                                    <Tooltip key={`TT_${i}`} className="blueTooltip" id={`tooltip_${i}`}>{kestr}</Tooltip>
                                                }>
                                                    {props.istMitarbeiter ? <Radio value={i >= beilagenArr.length ? 'Z' : beilagenArr[i]} key={'Radio_'+i}>
                                                        {theCardText}
                                                    </Radio>
                                                        : theCardText}
                                                </OverlayTrigger>
                                            )
                                        else
                                            return props.istMitarbeiter ? <Radio  value={i >= beilagenArr.length ? 'Z' : beilagenArr[i]} key={'Radio_'+i}>
                                                {theCardText}
                                            </Radio>
                                                : theCardText
                                    })
                                }
                                {sparseRows}
                            </StatelessRadioGroupField>
                        </>
                    </ ListGroup>
                </Card.Body>
            </Card>
        )
    }
}

export default KompList;